// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"888":"081ab2ec03bfa29d","894":"99adb502cbe7a807"}[chunkId] + ".css";
};